import axios, { AxiosInstance } from 'axios';
import { AXIOS_TIMEOUT } from '@/utils/const';

/**
 * Axios client for the pages anonymous visitors open — today the public
 * yahrzeit submission form.
 *
 * Deliberately not `@/api/base`: that instance attaches the admin's session
 * token and, on a 401/403, dispatches LOGOUT and pushes the browser to /login.
 * For a visitor who never had a session that is the wrong answer to every
 * failure, and for an admin who happens to open their own public link it would
 * sign them out. This client sends no credentials and lets the caller handle
 * failures in-page.
 */
const publicAPI: AxiosInstance = axios.create({
  baseURL: `${
    process.env.NODE_ENV === 'development'
      ? process.env.VUE_APP_LOCAL_SERVER_URL
      : process.env.VUE_APP_SERVER_URL
  }/${process.env.VUE_APP_VERSION}`,
  headers: {
    'Content-type': 'application/json',
  },
  timeout: AXIOS_TIMEOUT,
});

export default publicAPI;
